import { render } from "./cp.vue?vue&type=template&id=0967dd06&scoped=true"
import script from "./cp.vue?vue&type=script&lang=js"
export * from "./cp.vue?vue&type=script&lang=js"

import "./cp.vue?vue&type=style&index=0&id=0967dd06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0967dd06"

export default script